<template>
  <div>
    <van-sticky>
      <van-tabs
        class="div-tab"
        :border="false"
        :active="active"
        :before-change="onChange"
        :ellipsis="false"
      >
        <van-tab title="全部" name="ALL_ORDER"></van-tab>
        <van-tab title="待发货" :info="num.waitSentCount==0?'':num.waitSentCount" name="WAIT_SEND"></van-tab>
        <van-tab
          v-if="power['SYSTEM_SHIPPING']"
          title="待揽件"
          name="WAIT_COLLECT"
          :info="num.waitCollectCount==0?'':num.waitCollectCount"
        ></van-tab>
        <van-tab
          title="待收货"
          :info="num.waitReceiveCount==0?'':num.waitReceiveCount"
          name="WAIT_RECEIVING"
        ></van-tab>
        <van-tab title="待付款" :info="num.waitPayCount==0?'':num.waitPayCount" name="WAIT_PAY"></van-tab>
        <van-tab title="待分享" :info="num.groupWaitShareCount==0?'':num.groupWaitShareCount" name="GROUP_WAIT_SHARE"></van-tab>


        <van-tab title="已完成" name="COMPLETED"></van-tab>
      </van-tabs>
      <div class="tab-sx"> 
        <div class="item">
          <div class="tex0" @click="keywordVisible = !keywordVisible">
            <van-field class="tex1" readonly v-model="currtKeyword"/>
            <van-icon class="tex1icon" name="arrow-down" color="#999999" size="14"/>
          </div>
          <van-field v-show="currtkeyworkIndex == 0" class="tex2" v-model="searchval" placeholder="请输入" />
          <van-field v-show="currtkeyworkIndex == 1" type="digit" class="tex2" v-model="todayIncrNum" placeholder="请输入" />
          <van-field v-show="currtkeyworkIndex == 2" class="tex2" v-model="goodsCode" placeholder="请输入" />
          <van-button icon="search" class="btn" @click="serchFun"></van-button>
        </div>
        <div class="dv2">
          <FilterItem :display="displayIcon" @onClick="clickTimeIcon" :onFixed="false" height="70"></FilterItem>
        </div>
      </div>
      <div v-show="sortVisible" class="tab-ls">
        <button :class="orderBy=='asc'? 'seleted': 'none'" @click="sortFun('asc')">下单时间正序</button>
        <button :class="orderBy=='desc'? 'seleted': 'none'" @click="sortFun('desc')">下单时间倒序</button>
        <button :class="orderBy=='phone'? 'seleted': 'none'" @click="sortFun('phone')">相同收件人排序</button>
      </div>
      <div
        v-if="active == 'WAIT_COLLECT'"
        class="tab-lj"
        :class="list.length >1 && printStatus == '0' ? 'tleft' : 'tcenter'"
      >
        <button @click="changePrintStatus('0')" :class="['r10', printStatus=='0' ? 'c1' : 'c2']">待打印</button>
        <button @click="changePrintStatus('1')" :class="['r10', printStatus=='1' ? 'c1' : 'c2']">已打印</button>
        <button v-if="power['PRINT_PICKING_LIST'] && printStatus == '0'&&(isShadwUser == 1?false:true)" @click="checkPickingFun" class="pil">一键打印拣货单</button>
        <button
          v-if="list.length >1 && printStatus == '0'"
          class="pil"
          @click="yesPi = !yesPi"
        >{{yesPi ?'取消批量' :'批量操作'}}</button>
      </div>
      <div class="tab-lj" v-if="active == 'WAIT_SEND' && (power['CASHIER_SYSTEM_INPUT'] || power['PRINT_PICKING_LIST']) &&(isShadwUser == 1?false:true)">
        <button v-show="power['CASHIER_SYSTEM_INPUT']" @click="changeFamiliesPassStatus('1')" :class="['r10', familiesPassStatus=='1' ? 'c1' : 'c2']">待录科传</button>
        <button v-show="power['CASHIER_SYSTEM_INPUT']" @click="changeFamiliesPassStatus('2')" :class="['r10', familiesPassStatus=='2' ? 'c1' : 'c2']">已录科传</button>
        <button v-show="power['PRINT_PICKING_LIST'] && list.length >0" @click="openFun({orderType:orderTypeQuery, orderStatus:'WAIT_SEND'},'2','1')" class="pil rig">一键打印拣货单</button>
      </div>
    </van-sticky>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        style="min-height: 93vh"
        v-model="isLoading"
        :finished="finished"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        finished-text="没有更多数据"
        @load="getInit"
      >
        <div class="byg">
          <AdSwiper
            width="710"
            paddingBottom="20"
            code="workplace_myorder_01_001"
            groupCode="workplace_myorder_01"
            :refreshing="refreshing"
          />
          <div  v-for="(item,index) in list" :key="index" class="itemsuborder" >
            <normalItem
              :from="'normalorder'"
              :item.sync="item"
              :subOrderList = "item.subOrderList || []"
              :cIndex="index"
              :isPower="power"
              :yesPi="yesPi"
              :active="active"
              role="bees"
              :familiesPassStatus="familiesPassStatus"
              @callbackFun="callbackFun"
              @callbackChoose="callbackChoose"
              @printCodeFunBySingel="printCodeFun"
              @callbackFunByCancel="callbackFunByCancel"
              @callbackRemark="serchFun"
              @expressCode="onExpressCode"
              @repectFile="onRepectFile"
            >
            </normalItem>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <AllCheckSelect :isPower="power" ref="AllCheckSelectRef" :yesPi="yesPi" :choosedList.sync="choosedList" :printCodeFunLoading="printCodeFunLoading" @checkboxAllFun="checkboxAllFun" @printCodeFun="printCodeFun"></AllCheckSelect>
    <van-popup
      v-model="showCodePop"
      position="bottom"
      closeable
      close-icon-position="top-right"
      :style="{ height:'95%'}"
      :close-on-click-overlay="false"
      :close-on-popstate="true"
      :lock-scroll="true"
      :safe-area-inset-bottom="true"
    >
      <CodePop ref="codePopRef" v-if="showCodePop" :form.sync="pForm" :needReprint="needReprint" @closePopFun="closeCodePopFun"></CodePop>
    </van-popup>
    <van-popup 
      v-model="sendExpressCodePop"
      position="bottom"
      closeable
      close-icon-position="top-right"
    >
      <SendExpressCode :item="sendExpressItem" :postmanInfo="sendPostmanInfo" @cancelExpressSend="onCancelExpressSend" @updateExpressSend="onUpdateExpressSend"></SendExpressCode>
    </van-popup>
    <van-popup 
      v-model="repectFilePop"
      position="bottom"
      closeable
      close-icon-position="top-right"
    >
      <repectFile :repectFileInfo="repectFileInfo" :repectFileStatus="repectFileStatus" @cancelRepect="repectFilePop=false"></repectFile>
    </van-popup>
    <CodePopBefore ref="CodePopBefore" @callbackFun="callbackDeleteAll"></CodePopBefore>
    <PickModel ref="PickModel" @callbackFun="serchFun()"></PickModel>
    <van-popup 
      v-model="keywordVisible"
      position="bottom"
    >
      <!-- <div class="kwdiv">
        <ul class="ul">
          <li>取消</li>
          <li>确定</li>
        </ul>
        <div class="content">

        </div>
      </div> -->
      <van-picker
        :show-toolbar="true"
        confirm-button-text="完成"
        :columns="keywordList"
        @confirm="onConfirmBykeyword"
        @cancel="keywordVisible = false"
      />
    </van-popup>
    
  </div>
</template>
<script>
import http from "@/utils/axios";
import normalItem from "./components/normalItem";
import AdSwiper from "@/components/ad/swiper";
import CodePop from "./components/codePop";
import SendExpressCode from './components/sendExpressCode';
import repectFile from './components/repectFile';
import AllCheckSelect from "./components/select";
import FilterItem from "@/components/filter/item";
import CodePopBefore from "@/views/beeorder/components/codePopBefore";
import PickModel from "@/views/beeorder/components/pickModel";
export default {
  data() {
    return {
      isShadwUser:'0',
      num: {
        waitPayCount: "",
        waitSentCount: "",
        waitReceiveCount: "",
        afterOrderCount: "",
        groupWaitShareCount: ""
      },
      repectFilePop: false,
      repectFileInfo: {},
      repectFileStatus: false,
	    orderType: this.$route.query.orderType || '',
      orderTypeFormat:{
        '':'ALL_ORDER',
        '0':'ALL_ORDER',
        '1':'WAIT_PAY',
        '2':'WAIT_SEND',
        '3':'WAIT_RECEIVING',
        '4':'WAIT_COLLECT',
        '5':'COMPLETED',
      },
      orderTypeSymbol:{
        'ALL_ORDER':'0',
        'WAIT_PAY':'1',
        'WAIT_SEND':'2',
        'WAIT_RECEIVING':'3',
        'WAIT_COLLECT':'4',
        'COMPLETED':'5',
      },
      active: "ALL_ORDER",
      orderTypeQuery: this.$route.query.orderTypeQuery || 'all',
      orderTypeQueryFormat:{
        'all': '', //全部订单不传或者传空给接口
        'NORMAL_ORDER': 'NORMAL_ORDER',
        'QUICK_ORDER': 'QUICK_ORDER'
      },
      orderTypeQueryTitleCN:{
        '':'全部订单',
        'all': '全部订单',
        'NORMAL_ORDER': '预置订单',
        'QUICK_ORDER': '快速订单'
      },
      refreshing: false,
      isLoading: false,
      finished: false,
      list: [],
      error: false,
      pageNum: 1,
      pageSize: 20,
      power: {},
      printStatus: "",
      yesPi: false,
      choosedList: [],
      printCodeFunLoading: false,
      showCodePop: false,
      sendExpressCodePop: false,
      sendPostmanInfo: {},
      sendExpressItem: {},
      pForm: {},
      searchval:'',
      orderBy:'desc', // desc asc
      startTime:'',
      endTime:'',
      displayIcon:{
        one: {show:false},
        two: {show:false},
        three:{
          showIcon:true,
          showIconBySingle:false,
          name:'时间',
          key:'down', 
          actived:false
        },
        four:{active:false},
      },
      queryBranchType:0,
      branchRemarkType:'',
      needReprint:'',
      familiesPassStatus: '', //科传状态，1未入科传，2已录入科传
      justOnceTime: false,
      successful:true,
      keywordVisible: false,
      keywordList:['订单号、收件人地址、手机号、姓名', '订单序号', '商品编码'],
      currtKeyword:'订单号、收件人地址、手机号、姓名',
      currtkeyworkIndex:0,
      todayIncrNum: '',
      goodsCode: '',
      isUrge:'',  // 催单状态：1-已催单，0-未催单
      isTran: '',  // 自提功能-1邮寄 2门店自提
      orderGoodsType:"", // 0-商品，1-赠品
      sortVisible: false,
    };
  },
  methods: {
    isPrintTieckt() {
      if (window.navigator.userAgent.indexOf('client-info') > -1) {
          let b = window.navigator.userAgent;
          b = b.split('client-info=')[1];
          let c = JSON.parse(b);
          let user_id = c.user_id || '';
          if (user_id) {
            http({
              url: "order/admin/express/printConfig/" + user_id,
              method: "GET",
              parmes: {}
            }).then(res => {
              if (res.code == 200 && res.data) {
                let isEnableTicket = res.data.isEnableTicket || '禁用'
                localStorage.setItem('isEnableTicket',isEnableTicket)
              }
            })
          }
      }else {
        localStorage.setItem('isEnableTicket','禁用')
        // localStorage.setItem('isEnableTicket','启用')

      }
    },
    onExpressCode(item) {
      let that = this
      this.sendExpressCodePop = true
      this.sendExpressItem = item
      that.onGetPostmanInfo()
    },
    onCancelExpressSend () {
      this.sendExpressCodePop = false
      this.onLoad()
    },
    onUpdateExpressSend (event) {
      let that = this
      let index = that.list.findIndex(item => item.id == event.item.id)
      if (index != -1) {
        that.list[index].pushButtonStatus = event.status
        if (event.pushId) {
          that.list[index].pushId = event.pushId
        }
      }
      that.sendExpressCodePop = false
    },
    onGetPostmanInfo() {
      let that = this
      http({
        url: "order/express/push/postman",
        method: "GET",
        parmes: {}
      }).then((rps) => {
        if (rps.code === 200) {
          that.sendPostmanInfo = rps.data
        }
      }).catch((rps) => {});
    },
    onRepectFile(item) {
      let that = this
      that.repectFilePop = true
      http({
        url: "order/express/receipt/" + item.id,
        method: "GET",
        parmes: {}
      }).then((rps) => {
        if (rps.code == 200 && Object.keys(rps.data).length > 0) {
          that.repectFileStatus = true
          that.repectFileInfo = rps.data
        } else {
          that.repectFileStatus = false
        }
      }).catch((rps) => {});
    },
    onChange(tab) {
      console.log(tab, 888);
      if(this.successful){
        return false;
      }
      if(this.active === tab){
        return
      }
      this.active = tab;
      this.setAllChooseBackInit()
      this.setOrderByParmFun()
      this.setFamiliesPassStatusFun()
      let idx = this.orderTypeSymbol[this.active]
      this.$router.replace({query: { orderType: idx, orderTypeQuery: this.orderTypeQuery }});
      //针对安卓APP,每次修改了路由参数如果头部标题有变化都得传，不然就会取原路由title
      document.title = this.orderTypeQueryTitleCN[this.orderTypeQuery];
      this.setSortStyle(tab);
      this.finished = false;
      this.serchFun();
    },
    setAllChooseBackInit(){
      this.yesPi = false
      this.setRefStatusFun()
      this.choosedList = []
    },
    onRefresh() {
      this.setAllChooseBackInit()
      setTimeout(() => {
        this.pageNum = 1;
        this.list = [];
        //恢复不是最后一页
        this.finished = false;
        this.onLoad();
        this.getOrderNumFun();
      }, 1000);
    },
    async getInit(){
      this.isLoading = false;
      if(!this.justOnceTime){
        this.power = await this.getPowerFun();
        this.setFamiliesPassStatusFun();
      }
      if(Object.keys(this.power).length !== 0){
        this.onLoad();
      }
    },
    onLoad() {
      this.isLoading = true;
      setTimeout(() => {
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }
      });
      let parmes = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        orderTypeQuery: this.orderTypeQueryFormat[this.orderTypeQuery],
        orderStatusQuery: this.active, //订单状态
        searchKey: this.searchval.trim(),
        todayIncrNum: this.todayIncrNum.trim(),
        goodsCode: this.goodsCode.trim(),
        orderBy: this.orderBy,
        startTime: this.startTime,
        endTime: this.endTime,
        branchRemarkType: this.branchRemarkType,
        isUrge:this.isUrge,
        isTran: this.isTran,
        queryBranchType:this.queryBranchType, // 影子店铺 0 1 2
        orderGoodsType:this.orderGoodsType
      };
      
      if(this.pageNum >1){
        parmes.totalCount = sessionStorage.getItem('orderPageIndexCount');
        parmes.lastSubId = this.list &&  this.list[this.list.length-1].id;
      }
      this.active == "WAIT_COLLECT" && (parmes.printStatus = this.printStatus);
      this.active == "WAIT_SEND" && (parmes.familiesPassStatus = this.familiesPassStatus);
      http({
        url: "/order/appOrder/bees/subOrder",
        method: "post",
        parmes: parmes,
      })
        .then((rps) => {
          if (rps.code === 200) {
            this.successful =false;
            this.error = false;
            if (rps.data.pages == 0) {
              this.finished = true;
            } else {
              if (rps.data.list.length === 0) {
                this.finished = true;
              } else {
                this.finished = false;
                this.pageNum++;
              }
             
              rps.data.list.forEach((item)=>{
                item.checked =false;
              })
              this.list = this.list.concat(rps.data.list);
              if (this.list.length != 0) {
                this.isShadwUser = this.list[0].shadowBranchIf
              }
            }
            this.isLoading = false;
            this.$loading.hide();
            if(this.pageNum==1){
              sessionStorage.getItem('orderPageIndexCount',rps.data.total)
            }
          }
        })
        .catch((rps) => {
          if(rps.code === 500){
            this.error = false;
            this.finished = true;
          }else{
            this.error = true;
          }
          this.isLoading = false;
          this.$loading.hide();
        });
    },
    getOrderNumFun() {
      http({
        url: "/order/bees/quickOrder/beesH5/orderCount",
        method: "post",
        parmes: {orderTypeQuery: this.orderTypeQueryFormat[this.orderTypeQuery],},
      }).then((rps) => {
        if (rps.code === 200) {
          for (const key in rps.data) {
            this.num[key] = rps.data[key];
          }
        }
      });
    },
    /**
     * 获取是否有揽件权限
     */
    async getPowerFun() {
      let res = {};
      await http({
        url: "order/app/accessControl/allowedList",
        method: "GET",
      })
        .then((rps) => {
          if (rps.code === 200) {
            this.justOnceTime = true;
            //防止当前账号什么权限都没开通，因为有接口先后访问的限制，前端为了方便一些逻辑上的控制，自定义了可以查看数据的权限
            res['SELF_POWER_LOOK']= 'SELF_POWER_LOOK'
            rps.data.forEach((element) => {
              res[element] = element;
              element == 'CASHIER_SYSTEM_INPUT' && (this.familiesPassStatus = '1')
            });
          }
        })
        .catch((rps) => {});
      return res
    },
    callbackFun(val) {
      this.list.splice(this.list.findIndex((item)=>{return item.id == val}),1);
      this.getOrderNumFun();
    },
    callbackFunByCancel(val){
      this.callbackFun(val)
      let idx = this.choosedList.findIndex((id)=>{return id == val})
      idx !== -1 && (this.choosedList.splice(idx,1))
    },
    changePrintStatus(status) {
      if(this.printStatus == status){
        return
      }
      this.printStatus = status;
      this.$loading.show();
      this.setAllChooseBackInit()
      this.list = [];
      this.pageNum = 1;
      this.onLoad();
    },
    /**
     * 全选
     */
    checkboxAllFun(val) {
      let list = JSON.parse(JSON.stringify(this.list));
      list.forEach((item, index) => {
        // this.$set(list, index, { ...item, checked: val });
        item.checked = val;
        // 赠品 选中
        item.subOrderList && item.subOrderList.forEach((_item,_index)=>{
          if(!_item.mergeSendCode){
            _item.checked = val
            // this.$set(_item, _index, {..._itemsub});
          }
        })
      });
      this.list = list;
      this.choosedList = [];
      this._choosedList = []
      this.choosedSubList = [];
      val && (this._choosedList = this.list.map((item) => {
          return item.id;
        }));
      if(val){
        this.list.forEach((item, index) => {
          // 赠品 选中
          item.subOrderList && item.subOrderList.forEach((_item,_index)=>{
            this.choosedSubList.push(_item.id)
          })
        });
      }
      this.choosedList = val ? [...this._choosedList,...this.choosedSubList] : [];
      console.log('choosedList',this.choosedList)
    },
    /**
     * 单选
     */
    callbackChoose(row, index) {
      console.log('this.choosedList',this.choosedList)
      // this.$set(this.list[index], "checked", !this.list[index].checked);
      row.checked && this.choosedList.push(row.id);
      !row.checked &&
        this.choosedList.splice(this.choosedList.indexOf(row.id), 1);
      this.choosedList.length == this.list.length && this.setRefStatusFun(true);
      this.choosedList.length != this.list.length && this.setRefStatusFun();
    },
    /**
     * deliveryType 1/2 生成二维码 / 拣货单方式
     * needReprint 标识是从待收货点击的快递码还是从其他入口点击快递码 待收货传1
     */
    printCodeFun(val = "", deliveryType='1', needReprint='') {
      console.log("printCodeFun -> deliveryType", deliveryType)
      if(val == 'all' && this.choosedList.length == 0){
        this.$toast('请勾选')
        return
      }
      if(deliveryType == '2'){
        let parm = {
          "orderQueryParam":{
            "branchRemarkType": this.branchRemarkType,
            "endTime": this.endTime,
            "orderBy": this.orderBy,
            "orderStatusQuery": this.active,
            "orderTypeQuery": this.orderTypeQueryFormat[this.orderTypeQuery],
            "printStatus": '0',
            "searchKey": this.searchval.trim(),
            "todayIncrNum": this.todayIncrNum.trim(),
            "goodsCode": this.goodsCode.trim(),
            "startTime": this.startTime,
          },											  
          "isPrintAll": 0,
          "subOrderIdList": this.choosedList
        }
        this.printCodeFunLoading = true;
        this.$refs["PickModel"] &&
        this.$refs["PickModel"].doPickingFun(parm);
      }else{
        if(needReprint == 1){
          this.$dialog.confirm({
            title: '打印快递面单',
            message: '如快递面单已损毁或丢失，可扫码重新打印快递面单',
            confirmButtonColor: '#F8A651'
          }).then(()=>{
            this.needReprint = 1;
            this.doPressP(val, needReprint)
          }).catch(()=>{})
        }else{
          this.doPressP(val, needReprint)
        }
      }
    },
    doPressP(val, needReprint){
      let parmes = {
        subOrderIdList: val == "all" ? this.choosedList : [val]
      }
      needReprint == 1 && (parmes.needReprint = needReprint);
      http({
        url: "order/express/printCode",
        method: "post",
        parmes: parmes,
      })
        .then((rps) => {
          this.pForm = rps.data;
          this.printCodeFunLoading = false;
          this.showCodePop = true;
          
          /**
           * 取消全选
           */
          this.$refs.AllCheckSelectRef.allChecked = false
          this.checkboxAllFun(false)
        })
        .catch((rps) => {
          this.printCodeFunLoading = false;
        });
    },
    setRefStatusFun(status){
      this.$refs['AllCheckSelectRef'] && (this.$refs['AllCheckSelectRef'].allChecked = status ? status : false)
    },
    clickTimeIcon(val){
      if(val.type == 'four'){
        this.$filterDrawer({
          visibleTimerInput: true,
          visibleTimerButton: true,
          visiblePriceInput: false,
          list: [
            {
              name: '备注',
              type: 'other',
              alias: 'markRes',
              idKey: 'id',
              valueKey: 'value',
              select: 'radio',
              data: [
                {id:4, value:'常规备注'},
                {id:1, value:'无货'},
                {id:3, value:'待调货'},
                {id:2, value:'部分有货'},
                {id:0, value:'无备注'}
              ]
            },
            {
              name: '异常订单',
              type: 'other',
              alias: 'urge',
              idKey: 'key',
              valueKey: 'value',
              select: 'radio',
              data: [
                {key:'1', value:'催发货'},
              ]
            },
            {
              name: '发货类型',
              type: 'other',
              alias: 'delivery',
              idKey: 'key',
              valueKey: 'value',
              select: 'radio',
              data: [
                {key:'1', value:'邮寄'},
                {key:'2', value:'门店自提'},
              ]
            },
            {
              name: '店铺类型',
              type: 'other',
              alias: 'queryBranchType',
              idKey: 'key',
              valueKey: 'value',
              select: 'radio',
              data: [
                {key:1, value:'真实店铺'},
                {key:2, value:'影子店铺'},
              ]
            },
            {
              name: '商品类别',
              type: 'other',
              alias: 'gift',
              idKey: 'key',
              valueKey: 'value',
              select: 'radio',
              data: [
                {key:'0', value:'商品订单'},
                {key:'1', value:'赠品订单'},
                {key:'2', value:'拼团订单'},
              ]
            }
          ],
          confirm: res => {
            console.log("clickTimeIcon -> res", res)
            if(res.queryBranchType && res.queryBranchType.length > 0){
              this.queryBranchType = res.queryBranchType[0]
            }
            if(res.queryBranchType && res.queryBranchType.length == 0){
              this.queryBranchType = 0
            }
            // 对备注入参赋值
            if(res.markRes && res.markRes.length > 0){
              this.branchRemarkType = res.markRes[0]
            }
            if(res.markRes && res.markRes.length == 0){
              this.branchRemarkType = ''
            }
            if(res.urge && res.urge.length > 0){
              this.isUrge = 1;
            }else{
              this.isUrge = 0;
            }

            // 对时间入参赋值
            res.start ? (this.startTime = res.start.time) : (this.startTime = '')
            res.end ? (this.endTime = res.end.time) : (this.endTime = '')

            // 对发货方式入参赋值
            if (res.delivery.length > 0 && res.delivery[0] == '2') {
              this.isTran = 2
            } else if (res.delivery.length > 0 && res.delivery[0] == '1') {
              this.isTran = 1
            } else {
              this.isTran = ''
            }
            if (res.gift.length > 0 && res.gift[0] == '0') {
              this.orderGoodsType = 0
            } else if (res.gift.length > 0 && res.gift[0] == '1') {
              this.orderGoodsType = 1
            } else if (res.gift.length > 0 && res.gift[0] == '2') {
              this.orderGoodsType = 2
            } else {
              this.orderGoodsType = ''
            }



            this.displayIcon['four'].active = res.state
            this.serchFun()
          }
        })
      }
      if(val.type.indexOf('three') != -1){
        if(this.active === 'WAIT_SEND' || this.active === 'WAIT_COLLECT'){
          this.sortVisible = !this.sortVisible;
          if(this.sortVisible === false){
            this.orderBy = '';
          }
        }else{
          val.type.indexOf('up') > 0 && (this.orderBy = 'asc')
          val.type.indexOf('down') > 0 && (this.orderBy = 'desc')
          this.serchFun()
        }
      }
    },
    serchFun(){
      this.$loading.show();
      this.pageNum = 1
      this.list = []
      this.onLoad()
    },
    openFun(item ={}, printType, isPrintAll) {
      let parm ={
        "branchRemarkType": this.branchRemarkType,
        "endTime": this.endTime,
        "orderBy": this.orderBy,
        "searchKey": this.searchval.trim(),
        "todayIncrNum": this.todayIncrNum.trim(),
        "goodsCode": this.goodsCode.trim(),
        "startTime": this.startTime,
      }
      this.$refs["CodePopBefore"] &&
        this.$refs["CodePopBefore"].getPowerFun(item, printType,isPrintAll, parm);
    },
    callbackDeleteAll(){
      this.getOrderNumFun()
      this.list = []
    },
    checkPickingFun(){
      let parm ={
        "branchRemarkType": this.branchRemarkType,
        "endTime": this.endTime,
        "orderBy": this.orderBy,
        "orderStatusQuery": this.active,
        "orderTypeQuery": this.orderTypeQueryFormat[this.orderTypeQuery],
        "printStatus": '0',
        "searchKey": this.searchval.trim(),
        "todayIncrNum": this.todayIncrNum.trim(),
        "goodsCode": this.goodsCode.trim(),
        "startTime": this.startTime,
        "isPrintAll": '1',
        "subOrderIdList": []
      }
      this.$refs["PickModel"] &&
        this.$refs["PickModel"].init(parm);
    },
    setOrderByParmFun(){
      this.active == 'WAIT_SEND'?(
        this.orderBy = 'asc',
        this.displayIcon['three'].key='up'
      ) : (
        this.orderBy = 'desc',
        this.displayIcon['three'].key='down'
      )
      this.active == 'WAIT_COLLECT'?(
        this.printStatus = this.printStatus || '0'
      ):(
        this.printStatus = ''
      )
    },
    setFamiliesPassStatusFun(){
      this.active == 'WAIT_SEND' ? (
        this.power['CASHIER_SYSTEM_INPUT'] && (this.familiesPassStatus = this.familiesPassStatus || '1')
      ) : (
        this.familiesPassStatus = ''
      )
    },
    closeCodePopFun(){
      this.$refs['codePopRef'] && this.$refs['codePopRef'].closeFun()
      setTimeout(()=>{
        this.showCodePop = false
      },200)
    },
    changeFamiliesPassStatus(status){
      if(this.familiesPassStatus == status){
        return
      }
      this.familiesPassStatus = status;
      this.serchFun();
    },
    onConfirmBykeyword(val, index){
      console.log(index, 111);
      // console.log(val)
      this.currtKeyword = val;
      this.currtkeyworkIndex = index;
      this.keywordVisible = false;
      this.searchval= '';
      this.todayIncrNum= '';
      this.goodsCode = ''
    },
    sortFun(str){
      if(str === this.orderBy){
        return
      }
      this.orderBy = str;
      this.serchFun();
    },
    setSortStyle(active){
      let obj = {};
      if(['WAIT_SEND','WAIT_COLLECT'].includes(active)){
        obj = {
          showIcon:true,
          showIconBySingle:true,
          name:'排序',
          key:'up', 
          actived:false
        }
      }
      if(['ALL_ORDER','WAIT_PAY','WAIT_RECEIVING','COMPLETED'].includes(active)){
        this.sortVisible = false;
        obj = {
          showIcon:true,
          showIconBySingle:false,
          name:'时间',
          key:'down', 
          actived:false
        }
      }

      for (const key in obj) {
        this.displayIcon.three[key] = obj[key]
      }
    },
  },
  created() {
    this.isPrintTieckt()
    this.getOrderNumFun();
    this.active = this.orderTypeFormat[this.orderType];
    this.$route.query.orderTypeQuery == "all" && (document.title = "全部");
    document.title = this.orderTypeQueryTitleCN[this.orderTypeQuery];
    this.setOrderByParmFun();
    this.setSortStyle(this.active);

    window["reloadData"] = (res) => {
      //  console.log(res);
       let obj={};
      if(this.active =='WAIT_SEND'){
        if(typeof res ==='object'){
          obj = res;
        }else{
          obj = JSON.parse(res)
        }
        this.callbackFun(obj.subId)
        // console.log(this.list)
      }
    };
  },
  destroyed(){
    this.closeCodePopFun()
  },
  watch:{},
  components: { normalItem, AdSwiper,SendExpressCode,repectFile,CodePop,AllCheckSelect,FilterItem,CodePopBefore,PickModel},
};
</script>
<style lang="less" scoped>
/deep/.van-tab van-ellipsis {
  flex-basis: 20%;
  flex: 0 0 20%;
}
/deep/.van-card__bottom {
  text-align: right;
}
/deep/.van-card__price .van-card__price-integer {
  font-size: 16px;
}
/deep/.van-card__thumb img {
  border-radius: 0;
}
/deep/.van-tabs__line {
  background-color: var(--epButtonColor);
}
/deep/.van-info {
  color: #f8a651;
  background: #fff;
  border: 1px solid #f8a651;
}
.div-tab span {
  color: #333;
}
.tab-sx {
  background-color: #ffffff;
  height: 72px;
  font-size: 24px;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  /deep/.van-cell{
    padding: 0;
  }
  /deep/.van-field__control {
    height: 60px;
    background: #F7F7F7;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    -webkit-appearance: none;
    padding-left: 16px;
    color: #666666;
    font-size: 20px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  
    /deep/.van-button--default{
      border: 1px solid var(--epButtonColor) !important ;
    }
  /deep/.van-cell::after {
    border-bottom: 0px;
  }
  input{
    -webkit-appearance: none;
  }
  .btn{
    width: 60px;
    height: 60px;
    background: var(--epButtonColor);
    color:var(--epTextColor);
    border-radius: 10px;
    margin-left: -3px;
    display: flex;
    align-items: center;
    justify-content: center;
    img{
      width: 40px;
      height: 40px;
    }
  }
  .item {
    display: flex;
  }
  .dv2{
    width: 270px;
    // height: 70px;
  }
  .tex0{
    position: relative;
    width: 148px;
    background: #F7F7F7;
    border-radius: 10px;
    margin-right: 10px;
    .tex1{
      width: 110px;
      border-radius: 10px;
    }
    .tex1icon{
      position: absolute;
      right: 0;
      top: 0;
      margin-right: 5px;
      margin-top: 17px;
      background-color: #F7F7F7;
    }
  }
  .tex2{
    width: 203px;
  }
}
.tab-lj {
  width: 730px;
  height: 50px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 20px;
  background: #ffffff;
  font-size: 24px;
  border-top: 1px solid #f2f2f2;
  clear: both;
  button {
    min-width: 170px;
    height: 50px;
    border-radius: 10px;
    background-color: #ffffff;
    border: 2px solid rgba(248, 166, 81, 1);
  }
  .c1 {
    color: #f8a651;
    border: 1PX solid #f8a651;
  }
  .c2 {
    color: #999999;
    border: 1PX solid #999999;
  }
  .l20 {
    margin-left: 20px;
  }
  .r20 {
    margin-right: 20px;
  }
  .r10{
    margin-right: 10px;
  }
  .pil {
    margin-right: 10px;
    // float: right;
    background-color: var(--epButtonColor);
    color: var(--epTextColor);
    border: 1PX solid var(--epButtonColor);
  }
  .rig{
    float: right;
  }
}
.tab-ls{
  display: flex;
  justify-content: space-between;
  padding: 10px 20px;
  border-top: 1PX solid #EEEEEE;
  // border-bottom: 1PX solid #EEEEEE;
  background-color: #ffffff;
  button {
    font-size: 24px;
    padding:10px 38px;
    border-radius: 10px;
    background-color: #ffffff;
  }
  .none{
    color: #333333;
    border: 1PX solid #999999;
  }
  .seleted{
    color: #ED3939;
    border: 1PX solid #ED3939;
  }
}
.tleft {
  text-align: left;
}
.tcenter {
  text-align: center;
}
.div-hed {
  background: #fff;
  padding: 0 0.4244rem;
  display: flex;
  height: 50px;
  font-size: 0.35rem;
  padding: 0.2rem 0.4rem;
  border-bottom: 1px solid #f0f0f0;
  font-weight: bold;
}
.div-lef {
  width: 80%;
  height: 50px;
  line-height: 50px;
  .info-sp {
    font-size: 0.35rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.div-rig {
  width: 20%;
  text-align: right;
  font-size: 0.35rem;
  height: 50px;
  line-height: 50px;
  span {
    margin-right: 0.2rem;
  }
}
.color-redo {
  color: #ff6633;
}
.color-red {
  color: red;
}
.byg {
  background: #F7F7F7;
  padding: 0.3rem;
  font-size: 16px;
  .itemsuborder{
    margin-bottom: 20px;
  }
}
.hrh {
  background-color: #fff;
  margin-bottom: 0.3rem;
  padding: 0.3rem;
}
.div-btn {
  width: 1.8rem;
  height: 0.8rem;
  line-height: 0.8rem;
  margin-left: 0.2rem;
  text-align: center;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  border-radius: 0.5rem;
  background: rgba(248, 213, 65, 1);
}
.yel {
  background: rgba(248, 213, 65, 1);
}
.wt {
  background: #fff;
  border: 0.014rem solid #333;
}
.cont-di {
  text-align: right;
}
.div-gon {
  font-weight: bold;
  font-size: 0.35rem;
  margin-bottom: 0.3rem;
  .span-gon {
    color: #ed3939;
  }
}
/deep/.rig {
  text-align: right;
}
/deep/.van-card__title {
  color: #333;
  font-size: 0.35rem;
  font-weight: bold;
}
/deep/.van-card__desc {
  margin-top: 0.5rem;
}
/deep/.van-card__price {
  display: block;
  color: #ed3939;
  font-size: 0.4rem;
  .van-card__price-integer {
    font-size: 0.4rem;
  }
}
/deep/.van-card__num {
  font-size: 0.4rem;
}
/deep/.van-popup--bottom {
  border-radius: 20px 20px 0px 0px;
}
/deep/.van-popup--bottom {
  background-color: #f7f7f7;
}
</style>
